import React from 'react';
import styled from 'styled-components';

const Parcelasdiv = ({number1Parcela, descripcionParcela, imgParcela, imgPlano, precioParcela}) => {
    return(
        <ParcelasdivCSS>
            <div className="div1">
                <h1 className = "h1divParcelas">{number1Parcela}</h1>
                <p>{ descripcionParcela }</p>
                <h3 className="precioParcela">{precioParcela}</h3>
            </div>
            <div className="div2">
                <img src = { imgParcela } alt="/"/>
                <img src = {imgPlano } alt="/"/>
            </div>
        </ParcelasdivCSS>
    )
}
export default Parcelasdiv;

const ParcelasdivCSS = styled.div`
    position: relative;
    margin:2%;
    height:60%;
    display: flex;
    &:nth-child(even) {
        color: #fff;
        background-color: #003333;
    }
    &:nth-child(odd) {
        color: #bf930d;
        background-color: #003333;
    }
    @media(max-width:820px) {
        display: block;
        height:160%;
        top:0%;
        margin-bottom:60%;
    }
    @media(max-width:768px) {
        display: block;
        height:120%;
        top:0%;
        margin-bottom:60%;
    }
    @media(max-width:700px) {
        display: block;
        height:120%;
        top:0%;
        margin-bottom:70%;
    }
    @media(max-width:620px) {
        display: block;
        height:120%;
        top:0%;
        margin-bottom:80%;
    }
    @media(max-width:550px) {
        display: block;
        height:120%;
        top:0%;
        margin-bottom:102%;
    }
    @media(max-width:480px) {
        display: block;
        height:100%;
        top:0%;
        margin-bottom:102%;
    }
    @media(max-width:420px) {
        display: block;
        height:100%;
        top:0%;
        margin-bottom:130%;
    }
    @media(max-width:360px) {
        display: block;
        height:100%;
        top:0%;
        margin-bottom:140%;
    }
    @media(max-width:340px) {
        display: block;
        height:100%;
        top:0%;
        margin-bottom:150%;
    }
    @media(max-width:320px) {
        display: block;
        height:100%;
        top:0%;
        margin-bottom:165%;
    }
    .div1 {
        width: 50%;
        height: 100%;
        @media(max-width:820px) {
        width: 100%;
        height:50%;
        }
        @media(max-width:768px) {
        width: 100%;
        height:60%;
        }
        @media(max-width:620px) {
        width: 100%;
        height:60%;
        }
        @media(max-width:550px) {
        width: 100%;
        height:70%;
        }
        @media(max-width:480px) {
        width: 100%;
        height:70%;
        }
        @media(max-width:420px) {
        width: 100%;
        height:70%;
        }
        @media(max-width:370px) {
        width: 100%;
        height:70%;
        }
        @media(max-width:340px) {
        width: 100%;
        height:75%;
        }
        @media(max-width:320px) {
        width: 100%;
        height:80%;
        }
    }
    .div1 .h1divParcelas {
        border: 2px solid green;
        margin: 0%;
        height:14%;
        color: #000000;
        background-color: #fff;
        @media(max-width:820px) {
            height: 12%;
            font-size:230%;
        }
        @media(max-width:768px) {
            height: 12%;
            font-size:230%;
        }
        @media(max-width:620px) {
            height: 10%;
            font-size:200%;
        }
        @media(max-width:550px) {
            height: 10%;
            font-size:200%;
        }
        @media(max-width:480px) {
            height: 10%;
            font-size:200%;
        }
        @media(max-width:420px) {
            height: 10%;
            font-size:200%;
        }
        @media(max-width:370px) {
            height: 10%;
            font-size:200%;
        }
        @media(max-width:320px) {
            height: 10%;
        }
    }
    
    .div1 p {
        margin: 2%;
        margin-bottom:0%;
        height:60%;
        font-family: widen latin;
        font-size: 190%;
        font-weight: bold;
        @media(max-width:1100px) {
            font-size:150%;
            height:60%;
        }
        @media(max-width:1024px) {
            font-size:150%;
            height:60%;
        }
        @media(max-width:820px) {
            font-size:200%;
            height:50%;
        }
        @media(max-width:730px) {
            font-size:200%;
            height:50%;
        }
        @media(max-width:650px) {
            font-size:200%;
            height:60%;
        }
        @media(max-width:550px) {
            font-size:190%;
            height:60%;
        }
        @media(max-width:480px) {
            font-size:170%;
            height:60%;
        }
        @media(max-width:420px) {
            font-size:170%;
            height:70%;
        }
        @media(max-width:370px) {
            font-size:170%;
            height:70%;
        }
        @media(max-width:320px) {
            font-size:170%;
            height:70%;
        }
    }
    
    .div1 .precioParcela {
        height:18%;
        font-family: widen latin;
        font-size: 300%;
        text-align: center;
        margin:0%;
        @media(max-width:1100px) {
            font-size: 170%;
            margin-top:2%;
            height:18%;
        }
        @media(max-width:1024px) {
            font-size: 200%;
            margin-top:2%;
            height:18%;
        }
        @media(max-width:820px) {
            font-size: 300%;
            margin-top:2%;
            height:18%;
        }
        @media(max-width:550px) {
            font-size: 250%;
            margin-top:2%;
            height:18%;
        }
        @media(max-width:480px) {
            font-size: 200%;
            margin-top:2%;
            height:15%;
        }
        @media(max-width:420px) {
            font-size: 190%;
            margin-top:2%;
            height:15%;
        }
        @media(max-width:370px) {
            font-size: 190%;
            margin-top:2%;
            height:15%;
        }
        @media(max-width:370px) {
            font-size: 190%;
            margin-top:2%;
            height:15%;
        }
    }
    .div2 {
        width: 50%;
        border: 2px solid green;
        height: 100%;
        display: flex;
        @media(max-width:820px) {
        width: 100%;
        display: block;
        }
        @media(max-width:768px) {
        width: 100%;
        display: block;
        }
        @media(max-width:480px) {
        width: 100%;
        display: block;
        }
        @media(max-width:420px) {
        width: 100%;
        display: block;
        }
        @media(max-width:370px) {
        width: 100%;
        display: block;
        }
        @media(max-width:320px) {
        width: 100%;
        display: block;
        }
    }

    .div2 img{
        width: 50%;
        height: 100%;
        @media(max-width:820px) {
        width: 100%;
        display: block;
        height: 50%;
        }
        @media(max-width:768px) {
        width: 100%;
        display: block;
        height: 50%;
        }
        @media(max-width:480px) {
        width: 100%;
        display: block;
        height: 50%;
        }
        @media(max-width:420px) {
        width: 100%;
        display: block;
        height: 50%;
        }
        @media(max-width:370px) {
        width: 100%;
        display: block;
        height: 50%;
        }
        @media(max-width:320px) {
        width: 100%;
        display: block;
        height: 50%;
        }
    }

`;